// src/App.js
import React from "react";
import Encrypt from "../components/Encrypt";

function App() {
  return (
    <div className="App">
      <Encrypt />
    </div>
  );
}

export default App;
